import { useCallback, useEffect, useState } from "react";
import CadastroLeituraProduto from "../../components/produto/CadastroLeituraProduto";
import apiLeituraProduto from "../../services/apis/Leituras/apiLeituraProduto";
import getCurrentUnidadeId from "../../funcs/getCurrentUnidadeId";
import UltimasLeiturasAdicionadas from "../../components/produto/UltimasLeiturasAdicionadas";
import GraficosProdutos from "../../components/produto/GraficosProdutos";
import apiProduto from "../../services/apis/apiProduto";
import { getClientTimeZoneOffset, getUnidade } from "../../funcs";
import { format } from "date-fns";
import DatePickerGetDataPeriodo from "../../components/common/DatePickerGetDataPeriodo";
import useToast from "../../hooks/useToast";
import apiUnidade from "../../services/apis/apiUnidade";
import apiRelatorio from "../../services/apis/apiRelatorio";

export default function Produto() {

    const { erro } = useToast();
    
    const unidadeId = getCurrentUnidadeId();

    const [produtos, setProdutos] = useState([]);
    const [ultimasLeituras, setUltimasLeituras] = useState([]);
    const [isLoadingRelatorio, setIsLoadingRelatorio] = useState(false);
    const [ultimaDataPesquisada, setUltimaDataPesquisada] = useState(new Date());
    const [ultimoPeriodoPesquisado, setUltimoPeriodoPesquisado] = useState(new Date());
    const unidade = getUnidade();
    
    const fetchUltimasLeituras = useCallback(async () => {
        try {
            const res = await apiLeituraProduto.fecthUltimasLeituras(unidadeId, 3);
            setUltimasLeituras(res.data)
        } catch (error) {
            
        }
    },[unidadeId]);

    const onSearch = useCallback(async(date, periodo) => {

        try {
            const dto = {
                timeZoneNumber: getClientTimeZoneOffset(),
                data: format(date, "yyyy-MM-dd"),
                periodo: periodo
            }
            const res = await apiProduto.getChartProdutos(unidadeId, dto);
            setProdutos(res.data);
            setUltimaDataPesquisada(date);
            setUltimoPeriodoPesquisado(periodo);

        } catch (error) {
            
        }

    },[unidadeId])
 
    useEffect(() => {
        fetchUltimasLeituras();
        onSearch(new Date(), "mensal");
    },[fetchUltimasLeituras, onSearch]);

    const onSave = () => {
        fetchUltimasLeituras();
        onSearch(ultimaDataPesquisada, ultimoPeriodoPesquisado)
    }


    const gerarRelatorio = async (tempSelectedDateDe, tempSelectedDateAte) => {
        try {
            setIsLoadingRelatorio(true);
            const timeZoneOffset = getClientTimeZoneOffset();

            const dataInfo = {
                dataInicio: tempSelectedDateDe,
                dataFim: tempSelectedDateAte,
                TimeZoneNumber: timeZoneOffset
            }

            const dataInicioFormatada = dataInfo.dataInicio.toLocaleString('pt-BR', {
				day: '2-digit',
				month: '2-digit',
				year: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
				hour12: false 
			}).replaceAll(",", "_").replaceAll(" ", "");

            const dataFinalFormatada = dataInfo.dataFim.toLocaleString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            }).replaceAll(",", "_").replaceAll(" ", "");

            //se data inicio for maior que data final
            if (dataInfo.dataInicio > dataInfo.dataFim) {
                erro('Data de início precisa ser maior que data final');
                return;
            }

            const response = await apiRelatorio.relatorioLeituraProduto(unidade.id, dataInfo);
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
            const link = document.createElement('a');
            link.href = url;

            link.setAttribute('download', `Leituras_Produtos_${unidade.nome}_${dataInicioFormatada}-${dataFinalFormatada}.xlsx`);

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            erro(error.message);
        } finally {
            setIsLoadingRelatorio(false);
        }
    }

    return (
        <section className="flex flex-col pb-16 gap-y-4">
            <DatePickerGetDataPeriodo onSearch={onSearch} gerarRelatorio={gerarRelatorio} loading={isLoadingRelatorio}/>
            <GraficosProdutos produtos={produtos}/>
            <CadastroLeituraProduto onSave={onSave} />   
            <UltimasLeiturasAdicionadas ultimasLeituras={ultimasLeituras}/>
        </section>
    )
} 